import React from "react";

import { Button } from "../../components/ui";
import "./listing-preview-banner.scss";

// Shown on /product/:id when an admin views their own unpublished listing.
// Replaces the generic `<Alert type="info">`, which rendered on the light
// default alert surface and let its three buttons overflow the viewport.
//
// Fontaine M46A: the three hand-painted buttons are the one `ui/Button`. The two
// navigation actions are the Button itself rather than a `<Link>` wrapping a
// `<button>` — that shape nested an interactive control inside an interactive
// control, so a screen reader announced each cell twice and the button, not the
// link, took the focus ring. `rc-listing-preview__btn` survives as a layout hook
// only; all paint now comes from `ft-btn`.
const ListingPreviewBanner = ({
  listing,
  iframeQueryParams,
  publishStatus,
  onPublish,
}) => {
  const hasPrice = !!listing.price || listing.price === 0;
  const isSubmitting = publishStatus === "submitting";

  return (
    <div className="rc-listing-preview">
      <div className="rc-listing-preview__text">
        <span className="rc-listing-preview__badge">Draft</span>
        <h3 className="rc-listing-preview__title">Listing preview</h3>
        <p className="rc-listing-preview__note">
          This listing is unpublished — only you can see it.
        </p>

        {!hasPrice && (
          <p className="rc-listing-preview__error">
            The price is missing and cannot be published.
          </p>
        )}
      </div>

      <div className="rc-listing-preview__actions">
        <Button
          type="button"
          variant="primary"
          size="md"
          fullWidth
          loading={isSubmitting}
          // Fontaine Button marks a loading control aria-disabled but leaves it
          // natively enabled. Both reasons this control was disabled — a missing
          // price and a publish already in flight — need the native attribute,
          // or a second click fires a second PUT.
          disabled={!hasPrice || isSubmitting}
          className="rc-listing-preview__btn"
          onClick={onPublish}
        >
          Publish
        </Button>

        <Button
          to={`/rc/listings?${iframeQueryParams}`}
          variant="ghost"
          size="md"
          fullWidth
          className="rc-listing-preview__btn"
        >
          Save draft
        </Button>

        <Button
          to={`/product/${listing.id}/edit/product?${iframeQueryParams}`}
          variant="ghost"
          size="md"
          fullWidth
          className="rc-listing-preview__btn"
        >
          Edit
        </Button>
      </div>
    </div>
  );
};

export default ListingPreviewBanner;
